import { useEffect, useState } from 'react';
import axios from 'axios';

/**
 * Returns whether the current user's org has the Surveys module enabled.
 * Cached in sessionStorage to avoid repeated API calls.
 *
 * For super_admin (no org), returns `true` (they can see all surveys).
 * For users with org but flag=false, returns `false` (sidebar hidden).
 */
export function useSurveysModuleEnabled(user) {
    const [enabled, setEnabled] = useState(false);

    useEffect(() => {
        if (!user) { setEnabled(false); return; }
        if (user.role === 'super_admin') { setEnabled(true); return; }
        const orgId = user.organization_id;
        if (!orgId) { setEnabled(false); return; }

        const cacheKey = `surveys_enabled_${orgId}`;
        const cached = sessionStorage.getItem(cacheKey);
        if (cached !== null) {
            setEnabled(cached === '1');
            return;
        }

        const token = localStorage.getItem('yulontap_token');
        // Runtime origin — same pattern as lib/api.js. Avoids CRA baking a
        // stale preview URL into the production bundle.
        const base = typeof window !== 'undefined' ? window.location.origin : '';
        axios.get(`${base}/api/organizations/${orgId}`, {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
        })
            .then(r => {
                const isOn = !!r.data?.surveys_module_enabled;
                sessionStorage.setItem(cacheKey, isOn ? '1' : '0');
                setEnabled(isOn);
            })
            .catch(() => setEnabled(false));
    }, [user?.organization_id, user?.role]);

    return enabled;
}
